
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import UniversityCard from './UniversityCard.vue'
import PageContainer from '~/components/Containers/PageContainer.vue'
import { ContainerOptions } from '~/model'
import SwiperContainer from '~/components/Containers/SwiperContainer.vue'

@Component({
  components: {
    UniversityCard,
    PageContainer,
    SwiperContainer
  }
})
export default class extends Vue {
  @Prop({
    default: () => {}
  })
  readonly containerOptions!: ContainerOptions

  @Prop({
    default: () => [
      {
        id: 'card1',
        name: 'Российский экономический университет имени Г.В. Плеханова',
        image: '/icons/examples/univer-logo-example.png',
        programs: '2 программы по профессии',
        price: 'от 230 000 руб. в год'
      },
      {
        id: 'card2',
        name: 'Российский экономический университет имени Г.В. Плеханова',
        image: '/icons/examples/univer-logo-example.png',
        programs: '2 программы по профессии',
        price: 'от 230 000 руб. в год'
      },
      {
        id: 'card3',
        name: 'Российский экономический университет имени Г.В. Плеханова',
        image: '/icons/examples/univer-logo-example.png',
        programs: '2 программы по профессии',
        price: 'от 230 000 руб. в год'
      },
      {
        id: 'card4',
        name: 'Российский экономический университет имени Г.В. Плеханова',
        image: '/icons/examples/univer-logo-example.png',
        programs: '2 программы по профессии',
        price: 'от 230 000 руб. в год'
      },
      {
        id: 'card5',
        name: 'Российский экономический университет имени Г.В. Плеханова',
        image: '/icons/examples/univer-logo-example.png',
        programs: '2 программы по профессии',
        price: 'от 230 000 руб. в год'
      },
      {
        id: 'card6',
        name: 'Российский экономический университет имени Г.В. Плеханова',
        image: '/icons/examples/univer-logo-example.png',
        programs: '2 программы по профессии',
        price: 'от 230 000 руб. в год'
      }
    ]
  })
  readonly universityCards!: []

  desktopSliderOptions = {
    loop: false,
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 10,
    navigationId: 'un-next'
  }

  tabletSliderOptions = {
    loop: false,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 10,
    pagination: true
  }

  clickCard(card: any) {
    this.$emit('on-uni-card-click', card)
  }
}
